module.exports = __webpack_public_path__ + "img/care-teams.810fc35c.jpg";